import React, {useRef} from 'react';

import './LabelFileSelector.scss'
import {Box} from "@mui/material";


interface ILabelFileSelector {
    fileId: string;
    accept?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: () => void;
    multiple?: boolean;
    isDisabled?: boolean
}

const LabelFileSelector: React.FC<ILabelFileSelector> = (props) => {

    const inputRef: React.LegacyRef<HTMLInputElement> = useRef(null);

    return (
        <>
            <label htmlFor={props.fileId} className="label_file_selector" style={{
                pointerEvents: props.isDisabled ? "none" : "auto",
                width: "100%"
            }}>
                <Box color={"#ffffff"} sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "center"
                }}>
                    {props.children}
                </Box>
            </label>

            <input
                id={props.fileId}
                ref={inputRef}
                hidden
                disabled={props.isDisabled}
                type="file"
                accept={props.accept ? props.accept : '*'}

                multiple={props.multiple ? props.multiple : false}
                onClick={() => {
                    //--------------------------------------------------//
                    // BUG FIX: to select the same file multiple times
                    if (props?.onClick) {
                        props?.onClick();
                    }
                    // bug fix: for chrome
                    if (inputRef.current !== null) {
                        inputRef.current!.value = '';
                    }

                    // bug fix: for firefox
                    return false;
                    //--------------------------------------------------//
                }}
                onChange={props.onChange}
            />
        </>
    )
}

export default LabelFileSelector;